import partial from 'lodash/partial';

import { useSelector } from '@lumapps/redux/react';

import { currentEventPageSelector } from '../ducks/selectors';

export const useCurrentEventPage = partial(useSelector, currentEventPageSelector);
